import { useCallback } from 'react';

import { useAddSectionFromTemplate } from 'react-hooks';

import {
  buildUnhideSectionParams,
  type UnhideSectionInput,
} from './buildUnhideSectionParams';
import type { MutationContext } from './mutationLane';

export type UnhideSection = (
  input: UnhideSectionInput,
  context: MutationContext
) => Promise<number>;

// `context.baseVersion` is not sent yet: it is the hook point for the
// expected version (TS-55794)
export function useUnhideSection(): UnhideSection {
  const { addSectionFromTemplate } = useAddSectionFromTemplate();

  return useCallback<UnhideSection>(
    async input => {
      const params = buildUnhideSectionParams(input);
      const { newVersion } = await addSectionFromTemplate(params);

      return newVersion;
    },
    [addSectionFromTemplate]
  );
}
